import React from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { Typography, Box } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useStyles } from './styles';
import { IBookingEvent } from '../../../../types';
import { selectUser, useAppDispatch } from '../../../../store';
import { useAppConfiguration } from '../../../shared/hook';
import { addOffering } from '../../../../store/common';
import OfferingCard from '../../../components/offering-card';
import FilteredOfferings from './FilteredOfferings';
import useGetEvents from '../../../shared/hook/use-get-events';

const OfferingSection = () => {
  const { withUnlimitedCredits } = useAppConfiguration();
  const classes = useStyles({ withUnlimitedCredits });
  const { communitySessions } = useGetEvents();
  const { user } = useSelector(selectUser);
  const history = useHistory();
  const dispatch = useAppDispatch();

  const getKeyValue = (key: string) => (obj: Record<string, any>) => obj[key];

  const groupedOfferingsByMonth = (offerings: IBookingEvent[]) => {
    const eventsWithStartMonth = offerings.map((obj: any) => ({
      ...obj,
      startMonth: moment(obj.sessions[0].startsAt).local().format('MMMM'),
    }));
    const groupedOfferings = eventsWithStartMonth.reduce((group, event) => {
      const { startMonth } = event;
      group[startMonth] = group[startMonth] ?? [];
      group[startMonth].push(event);
      return group;
    }, {});

    return groupedOfferings;
  };

  const onUpcomingEvent = (offering: IBookingEvent) => {
    dispatch(addOffering({ offering }));

    history.replace({
      pathname: window.location.pathname,
      search: `offeringId=${offering.id.toString()}`,
    });
  };

  const renderOfferings = (
    filteredUpcomingEvents: IBookingEvent[],
    loading: boolean,
  ) => (
    <Box className={classes.offeringListWrapper}>
      {Object.keys(groupedOfferingsByMonth(filteredUpcomingEvents)).map(
        (key: any) => (
          <>
            <Typography variant="body1" className={classes.dateDivider}>
              {key}
            </Typography>
            <Box className={classes.offeringSection}>
              {getKeyValue(key)(
                groupedOfferingsByMonth(filteredUpcomingEvents),
              ).map((event: IBookingEvent) => (
                <Box className={classes.offering} key={event.id}>
                  <OfferingCard
                    upcomingEvent={event}
                    userCredit={user?.creditBalance}
                    onUpcomingEvent={onUpcomingEvent}
                    loading={loading}
                  />
                </Box>
              ))}
            </Box>
          </>
        ),
      )}
    </Box>
  );

  return (
    <FilteredOfferings
      upcomingEvents={communitySessions ?? []}
      render={renderOfferings}
    />
  );
};

export default OfferingSection;
